import { render } from "./SelectTable.vue?vue&type=template&id=b4df5aca&scoped=true"
import script from "./SelectTable.vue?vue&type=script&lang=js"
export * from "./SelectTable.vue?vue&type=script&lang=js"

import "./SelectTable.vue?vue&type=style&index=0&id=b4df5aca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4df5aca"]])

export default __exports__